import React from 'react';
import {Control, ErrorComponent, Checkbox} from 'MWComponents';
import '../less';
import smile_img from '../img/smile.png';
import css from '../../Express/less/form/form.m.less';

export default function template() {
    const model = this.getModel(),
        {simpleMode, attribute} = this.props,

        {customerName, contactPhoneNumber, agree, adress, companyName, okpo, sum, message} = model.fields,

        okpoField =
          ['deposits_business', 'light-house', 'yuo'].includes(attribute) ? (
            <div className="send-form__item">
              <input
                type="text"
                className={`custom-input ${
                  !okpo.isValid && !okpo.firstInput ? 'red-color' : ''
                }`}
                name="okpo"
                value={okpo.value}
                onChange={this.handleChange}
                placeholder={this.l10n(
                  attribute === 'yuo'
                    ? 'BUSINESS_ORDER_MODAL_OKPO_INN_FIELD_PLACEHOLDER_YUO'
                    : 'BUSINESS_ORDER_MODAL_OKPO_INN_FIELD_PLACEHOLDER'
                )}
                onBlur={() => this.onBlurHandle('okpo')}
                maxLength={100}
                autoComplete="off"
              />

              <div className="error">
                <div
                  className={`error__message ${
                    okpo.errors.length && !okpo.firstInput ? 'active' : ''
                  }`}
                >
                  {this.l10n(okpo.errors.join('.'))}
                </div>
              </div>
            </div>
          ) : '',

          companyNameField = (
            (attribute === 'leasing' || attribute === 'tso') ? (
              <div className="send-form__item">
                <input
                  type="text"
                  className={`custom-input ${
                    !companyName.isValid && !companyName.firstInput
                      ? 'red-color'
                      : ''
                  }`}
                  name="companyName"
                  value={companyName.value}
                  onChange={this.handleChange}
                  placeholder={attribute === 'leasing' ? this.l10n('BUSINESS_GUARANTEES_LABEL_7') : attribute === 'tso' ? this.l10n('BUSINESS_GUARANTEES_LABEL_6') : ''}
                  onBlur={() => this.onBlurHandle('companyName')}
                  maxLength={100}
                  autoComplete="off"
                />

                <div className="error">
                  <div
                    className={`error__message ${
                      companyName.errors.length &&
                      !companyName.firstInput
                        ? 'active'
                        : ''
                    }`}
                  >
                    {this.l10n(companyName.errors.join('.'))}
                  </div>
                </div>
              </div>
            ) : ''
          ),

        form = (
            <>
                <div
                  className="title"
                  dangerouslySetInnerHTML={{
                    __html: simpleMode
                      ? this.l10n('SEND_CARD_BUTTON_SEND_TITLE')
                      : this.l10n(
                          attribute === 'yuo'
                            ? 'BUSINESS_ORDER_MODAL_TITLE_YUO'
                            : attribute === 'esg'
                              ? 'BUSINESS_ORDER_MODAL_TITLE_ESG'
                              : 'BUSINESS_ORDER_MODAL_TITLE'
                        ),
                  }}
                ></div>
                {(attribute === 'light-house' || attribute === 'leasing') && <div className="business-order-text" dangerouslySetInnerHTML={{__html: this.l10n('BUSINESS_ORDER_MODAL_TEXT')}}></div>}
                <div className="send-form">
                  { !simpleMode && attribute !== 'esg' ?
                  <div className="send-form__item">
                    <input
                      type="text"
                      className={`custom-input ${
                        !customerName.isValid && !customerName.firstInput ? 'red-color' : ''
                      }`}
                      name="customerName"
                      value={customerName.value}
                      onChange={this.handleChange}
                      placeholder={this.l10n(
                        attribute === 'leasing'
                          ? 'BUSINESS_GUARANTEES_LABEL_1_LEASING'
                          : attribute === 'yuo'
                            ? 'BUSINESS_GUARANTEES_LABEL_1_YUO'
                            : 'BUSINESS_GUARANTEES_LABEL_1'
                      )}
                      onBlur={() => this.onBlurHandle('customerName')}
                      maxLength={100}
                      autoComplete="off"
                    />

                    <div className="error">
                      <div
                        className={`error__message ${
                          customerName.errors.length && !customerName.firstInput
                            ? 'active'
                            : ''
                        }`}
                      >
                        {this.l10n(customerName.errors.join('.'))}
                      </div>
                    </div>
                  </div>
                  : ''
                  }

                  {(attribute === 'deposits_business' || attribute === 'light-house') && okpoField}

                  {(attribute === 'leasing') && companyNameField}

                    <div className="send-form__item">
                        <input
                            type="text"
                            className={`custom-input ${
                                !contactPhoneNumber.isValid && !contactPhoneNumber.firstInput
                                    ? 'red-color'
                                    : ''
                            }`}
                            name="contactPhoneNumber"
                            value={contactPhoneNumber.value}
                            onChange={this.handleChange}
                            placeholder={this.l10n(
                              attribute === 'yuo'
                                ? 'BUSINESS_GUARANTEES_LABEL_2_YUO'
                                : 'BUSINESS_GUARANTEES_LABEL_2'
                            )}
                            onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                            maxLength={20}
                            autoComplete="off"
                        />

                        <div className="error">
                            <div
                                className={`error__message ${
                                    contactPhoneNumber.errors.length &&
                                    !contactPhoneNumber.firstInput
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                {this.l10n(contactPhoneNumber.errors.join('.'))}
                            </div>
                        </div>
                    </div>

                  {attribute === 'esg' && (
                    <div className="send-form__item">
                      <textarea
                        className={`custom-input textarea ${!message.isValid && !message.firstInput ? 'red-color' : ''}`}
                        name="message"
                        value={message.value}
                        onChange={this.handleChange}
                        placeholder={this.l10n('BUSINESS_ORDER_MODAL_MESSAGE_PLACEHOLDER_ESG')}
                        onBlur={() => this.onBlurHandle('message')}
                        maxLength={1000}
                      />
                      <div className="error">
                        <div className={`error__message ${message.errors.length && !message.firstInput ? 'active' : ''}`}>
                          {this.l10n(message.errors.join('.'))}
                        </div>
                      </div>
                    </div>
                  )}

                  {attribute === 'yuo' && okpoField}

                  {attribute === 'leasing' &&
                    <div className="send-form__item">
                      <input
                        type="text"
                        className="custom-input sum"
                        name="sum"
                        value={sum ? sum.value : ''}
                        onChange={this.handleChange}
                        placeholder={this.l10n('BUSINESS_GUARANTEES_LABEL_8')}
                        maxLength={20}

                      autoComplete="off"
                      />
                    </div>
                  }

                  {attribute === 'tso' ?
                    <div className="send-form__item">
                      <input
                        type="text"
                        className={`custom-input ${
                          !adress.isValid && !adress.firstInput
                            ? 'red-color'
                            : ''
                        }`}
                        name="adress"
                        value={adress.value}
                        onChange={this.handleChange}
                        placeholder={this.l10n('BUSINESS_GUARANTEES_LABEL_5')}
                        onBlur={() => this.onBlurHandle('adress')}
                        maxLength={100}
                        autoComplete="off"
                      />

                      <div className="error">
                        <div
                          className={`error__message ${
                            adress.errors.length &&
                            !adress.firstInput
                              ? 'active'
                              : ''
                          }`}
                        >
                          {this.l10n(adress.errors.join('.'))}
                        </div>
                      </div>
                    </div>
                    :
                    ''
                  }
                  {attribute === 'tso' && companyNameField}
                </div>
              {!simpleMode ?
                <div className="i-agree-block">
                  <Checkbox
                    checked={agree.value}
                    onChange={e => this.selectItem('agree')}
                    className={`checkbox-agree ${attribute === 'leasing' ? 'leasing-agreement' : ''}`}
                  >
                        <span>
                            {this.l10n('BUSINESS_GUARANTEES_AGREE_1')}{' '}
                          {attribute === 'leasing' ? this.l10n('BUSINESS_GUARANTEES_AGREE_3') : this.l10n('BUSINESS_GUARANTEES_AGREE_2')}
                        </span>
                  </Checkbox>
                </div>
                : ''
              }
              {
                !simpleMode ?
                  <div className="button-wrapper">
                    <button
                      className="button button-order"
                      onClick={attribute === 'tso' ? () => this.sendTsoForm() : attribute === 'esg' ? () => this.sendEsgForm() : this.sendForm}
                      disabled={!model.isValid}
                    >
                      {this.l10n(attribute === 'esg' ? 'BUSINESS_ORDER_MODAL_SEND_ESG' : 'BUSINESS_ORDER_MODAL_SEND')}
                    </button>
                  </div>
                  :
                  <div className="button-wrapper">
                    <button
                      className="button button-order"
                      onClick={this.sendSimpleForm}
                    >
                      {this.l10n('SEND_CARD_BUTTON_SEND_TEXT')}
                    </button>
                  </div>
              }

            </>
        ),
        success = (
            <>
                <div className='success' style={{marginTop: '20px'}}>
                    <div className='success-title' >{this.l10n(attribute === 'yuo' ? 'BUSINESS_ORDER_RESULT_TITLE_YUO' : 'BUSINESS_ORDER_RESULT_TITLE')} <img src={smile_img} alt="smile_img" /></div>
                    {attribute !== 'esg' && <div className='success-subtitle' dangerouslySetInnerHTML={{__html: simpleMode ? this.l10n('SHOPING_ATB_MODAL_TEXT') : this.l10n('BUSINESS_ORDER_RESULT_SUBTITLE')}}></div>}
                    <button className='ok-btn' onClick={() => this.props.closeModal()}>{this.l10n(attribute === 'esg' ? 'BUSINESS_ORDER_RESULT_BTN_ESG' : 'BUSINESS_ORDER_RESULT_BTN')}</button>
                </div>
            </>
        ),
        error = (
            <Control className="control" style={{marginTop: '30px'}}>
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        ),
        screens = {
            form,
            success,
            error,
        };

    return (
        <div className="form-wrapper" onClick={this.closeModal}>
            <div className="form-container">
                <div className="close-btn" onClick={() => this.props.closeModal()} onKeyDown={(e) => e.key === 'Enter' && this.closeModal()} tabIndex="0"/>
                {screens[this.state.activeScreen]}
            </div>
        </div>
    );
}
